export const CertificationTime = 180000;

export const EmailDuplicationText = '다른회원이 사용중인 이메일입니다.';

export const IsLGPhoneNotice =
  '일부 제조사 기기에서 현재 지원되지 않는 기능입니다. 빠른 시일 내에 정상 서비스 진행하겠습니다. 양해 부탁 드립니다.';
